import type { DeviceConfigurationApi } from '@model/DeviceConfiguration';
import type { Device } from '@types';
import type { HydrateSessionEntry } from '../hooks/useWorkspaceSessions';
import { resolveSessionCompletedAt } from './resolveSessionCompletedAt';
import { resolveSessionSensorFields } from './sessionDevice';

const hasConfigurationHrData = (hrData: DeviceConfigurationApi['hrData']) => {
  if (hrData == null) return false;

  const normalized = String(hrData).trim();
  return normalized.length > 0 && normalized !== '[]' && normalized !== 'null';
};

export const buildHydrateEntryFromConfiguration = (
  sessionId: number,
  data: DeviceConfigurationApi,
  sensorDeviceLookup?: Map<string, Device>
): HydrateSessionEntry => {
  const sensorFields = resolveSessionSensorFields(data, sensorDeviceLookup);

  return {
    sessionId,
    patientCode: data.patientCode,
    sessionDate: data.started_at ?? data.created_at ?? null,
    completedAt: resolveSessionCompletedAt(data),
    deviceName: sensorFields.deviceName,
    deviceSensorName: sensorFields.deviceSensorName,
    hasHrData: hasConfigurationHrData(data.hrData),
    hasHrDataRepaired: Boolean(data.hrData_repaired),
  };
};
